<template>
  <div v-if="signatoriesCount > 1"
       class="my-2 text-caption font-weight-bold"
       style="color: #616161"
  >
    {{ $t('project.project-settings.signatures.ProjectSettingsSignaturesSignatoriesList.signatoriesListTitle') }}
  </div>

  <div class="d-flex flex-column row-gap-2">
    <ProjectSettingsSignaturesSignatory v-for="(signatory, index) in signatoriesList"
                                        :key="`signatory-${index}`"
                                        :item="item"
                                        :signatory="signatory"
    />
  </div>
</template>

<script>
import ProjectSettingsSignaturesSignatory from './ProjectSettingsSignaturesSignatory.vue'

export default {
  name: 'ProjectSettingsSignaturesSignatoriesList',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    ProjectSettingsSignaturesSignatory,
  },
  computed: {
    signatoriesList () {
      if (this.item.envelopeType === 'single') { return this.item.signatories.filter(s => s.signatureType !== 'witness') }

      return [...this.signatoriesCommonList, ...this.signatoriesUniqueList]
    },
    signatoriesCommonList () {
      return this.item.signatories.filter(signatory => !signatory.signers && signatory.signatureType !== 'witness')
    },
    signatoriesCount () {
      return this.signatoriesUniqueList.length + this.signatoriesCommonList.length
    },
    signatoriesUniqueList () {
      return this.item.signatories.find(signatory => signatory.signers)?.signers || []
    },
  },
}
</script>

<style lang="scss" scoped>
.ProjectSettingsSignatures-listDot {
  background-color: rgb(var(--v-theme-accent));
  border-radius: 50%;
  display: inline-block;
  height: 5px;
  margin-right: 5px;
  vertical-align: middle;
  width: 5px;
}
</style>
